<div class="animated fadeInRight" *ngIf="!mostrarFormulario">
    <app-lfsa-card 
      [innTemplate]="carga" [titulo]="titulo" [efecto]="true" [colapseName]="'carga'"
      [banderaColapse]='false' [optionsExport]="true" (devolverAccion)="downloadCsvFormato()">
    </app-lfsa-card>
  
    <ng-template #carga>
      <form [formGroup]="formulario" novalidate class="form-group">
        <div class="row align-items-center" style="height: 100px;">
          <div class="form-group col-md-6">
            <label for="csvInput" class="letrasDanger">documento de carga.csv*</label>
            <input type="file" class="form-control-file" id="csvInput" #fileInput (change)="onFileSelect($event)" accept=".csv" />
          </div>
  
          <div class="form-group col-md-6">
            <button (click)="enviarFormulario()" [disabled]="formulario.invalid || loading" class="btn btn-success btn-block">Procesar</button>
          </div>
        </div>
      </form>
      <br>

      <div *ngIf="loading">
        <app-lfsa-loading-v2></app-lfsa-loading-v2>
        <p class="text-center">Procesando por favor espere...</p>
      </div>

    </ng-template>
  </div>

  <div *ngIf="mostrarFormulario">
    <app-lfsa-card [colapseName]="'grid'" [efecto]="true" [innTemplate]="grid" 
      [titulo]="'DATOS PARA PROCESAR'" 
      [banderaColapse]='false' 
      [optionsExport] ="true" 
      (devolverAccion)="downloadDataCsv()">
    </app-lfsa-card>
  
    <ng-template #grid>
        <!-- GRILLA -->
        <div class="alert alert-danger" role="alert" *ngIf="listaVacia"> No existen datos para la lista.</div>
        <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
        <br>
        <ag-grid-angular #agGrid (gridReady)="onGridReady($event)"  
                        [id]    ="DAT_AG_GRID.id" 
                        [class] ="DAT_AG_GRID.class" 
                        [ngStyle]="DAT_AG_GRID.style" 
                        [rowData]="rowData" 
                        [columnDefs]="columnDefs"
                        [pagination]="DAT_AG_GRID.pagination" 
                        [paginationPageSize]="DAT_AG_GRID.pagina"
                        [allowContextMenuWithControlKey]="true"
                        [frameworkComponents]="frameworkComponents" >
        </ag-grid-angular>
        <!-- GRILLA -->
    </ng-template>
  
    <div class="row">
      <div class="form-group col-md-12">
        <button (click)="regresar()" class="btn btn-outline-danger btn-block btn-lg">Regresar</button>
      </div>
    </div>
    <br>
  </div>